import React, { useEffect, useState } from 'react';
import { IoCartOutline } from 'react-icons/io5';
import { useHistory, useLocation } from 'react-router';
import BackButton from '../../../components/backButton';
import ErrorToast from '../../../components/error_toast';
import Nav from '../../../components/Layout/user/nav';
import useGlobalContext from '../../../context/provider';
import {
  getAllCartItems,
  getStoreSharedCart,
} from '../../../context/actions/cart';
import { CartItem } from '../../../types/product';
import Spinner from '../../../components/spinner';
import store from '../../seller/store';
import SharedCartItem from './inc/cartItem';
import SEOHeader from '../../../components/SEO';

const SharedCart = () => {
  const history = useHistory();
  const [loading, setLoading] = useState<boolean>(false);
  const [openToast, setOpenToast] = useState<boolean>(false);
  const [message, setMessage] = useState<{
    type?: 'error' | 'warning' | 'success';
    text: string;
  }>();
  const [cart, setCart] = useState<CartItem[]>([]);

  useEffect(() => {
    const url = new URL(window.location.href);
    let search = url.searchParams;
    fetchStoresCart(search);
  }, []);

  useEffect(() => {
    if (message?.type) {
      setOpenToast(true);
    }
  }, [message]);

  const fetchStoresCart = async (params: URLSearchParams) => {
    setLoading(true);
    const res = await getStoreSharedCart(params);
    if (res.error) {
      setMessage({ type: 'error', text: res.error });
      setLoading(false);
      return;
    }

    setCart(res);
    setLoading(false);
    return;
  };
  return (
    <>
      <ErrorToast
        isOpen={openToast}
        message={message?.text!}
        onClose={() => {
          setOpenToast(false);
        }}
        type={message?.type!}
        position="bottom"
      />
      <SEOHeader
        title="Checkout My Cart | Bazaarcheap"
        description={
          cart.length > 1
            ? `My cart for ${cart[0].store.name}  on Bazaarcheap.com`
            : 'My Cart on Bazaarcheap.com'
        }
        url={window.location.href}
        ogImage={
          cart.length > 1
            ? cart[0]?.store.logo!
            : window.location.origin +
              '/assets/logo/logo_white_background_96.svg'
        }
      />
      <div className="w-full h-[10dvh] overflow-hidden flex flex-col items-center justify-evenly p-2 bg-white">
        <Nav />
      </div>
      <div className="w-full h-[90dvh] overflow-hidden flex flex-col items-center justify-evenly py-2 px-4 md:px-[10%]  bg-white">
        <div className="w-full h-[8%] md:h-[10%] flex items-center justify-start py-[1%]">
          <div className="h-full w-auto ml-2 flex items-center overflow-hidden py-[1%] md:py-[5px]">
            <span className="h-full w-auto aspect-square flex items-center justify-center mx-2">
              <IoCartOutline size="100%" className="size-full items-primary" />
            </span>
            <p className="w-auto text-2xl font-semibold text-primary">
              Shared Cart
            </p>
          </div>
        </div>
        <div className="w-full h-[90%] bg-background rounded-2xl p-2 ">
          <div className="size-full px-2 md:px-[12%] overflow-y-scroll">
            {cart.length ? (
              <div className=" relative w-full h-auto grid grid-cols-2 md:grid-cols-4 grid-flow-row-dense gap-2 my-4">
                {cart.map((item, index) => {
                  return (
                    <div
                      className="size-auto flex items-center justify-center"
                      key={`product-${item.id}`}
                    >
                      <SharedCartItem
                        product={{
                          ...item.product,
                          store: item.store,
                          count: item.count,
                        }}
                      />
                    </div>
                  );
                })}

                {loading ? (
                  <div className="absolute size-full z-20 flex items-center justify-center text-primary py-[4px] md:py-[3px] px-[2px] bg-[rgba(255,255,255,0.4)]">
                    <Spinner type="crescent" />
                  </div>
                ) : (
                  ''
                )}
              </div>
            ) : (
              <div className="size-full flex flex-col items-center justify-center px-8">
                <p className="text-lg font-normal font-roboto text-primary text-center">
                  No items here.
                  <span
                    className="text-blue-600 underline cursor-pointer mx-2"
                    onClick={() => {
                      history.push('/stores');
                    }}
                  >
                    Browse
                  </span>
                  to add items to your cart.
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default SharedCart;
